import React from "react";
import { useReportContext } from "./ReportContext";
import { IReportElement, IReportSlide } from "./ReprortContextTypes";
import { useSlideContext } from "./SlideContext";
import { DataElement } from "./types";

const TextElement = (
  props: React.PropsWithChildren<{ slideElement: string }>
) => {
  const slide = useSlideContext();

  // TODO: after rendering the element fetch the text data from inside of it
  const ref = React.useRef<HTMLDivElement>(null);
  const element = React.useRef<IReportElement>({
    isReady: false,
    type: "text",
    text: "",
    slideElement: props.slideElement,
    elementDefinition: slide!.slideDefinition?.elements
      .filter((el) => el.tag === props.slideElement)
      .pop(),
  });
  const report = useReportContext();
  React.useEffect(() => {
    slide?.addElement?.(element.current);
    if (ref.current) {
      if (element.current.elementDefinition) {
        const renderedElement = JSON.parse(
          JSON.stringify(element.current.elementDefinition)
        ) as DataElement;

        if (renderedElement.paragraphs) {
          const para = renderedElement.paragraphs[0];
          const port = para?.portions?.[0];
          if (port) {
            renderedElement.paragraphs = [para];
            para.portions = [port];
            para.text = "";
            port.text = ref.current.innerText;
            renderedElement.slideElement = renderedElement.tag;
            element.current.rendered = renderedElement;
          }
        }
      }
      element.current.text = ref.current.innerText;
      slide?.onElementReady?.(element.current);
    }
  }, [ref, report]);

  return <div ref={ref}>{props.children}</div>;
};

export default TextElement;
